import type { LandmarkMap, LandmarkName } from "@studystraight/shared-types";
import type { NormalizedLandmark } from "@mediapipe/tasks-vision";

/**
 * BlazePose 33 keypoint → 7 landmark mà StudyStraight dùng (§6, §13).
 *
 * Đây là chỗ DUY NHẤT trong toàn bộ codebase biết đến index của MediaPipe. Đổi sang pose engine
 * khác (MLKit trên React Native) chỉ cần thay file này.
 */
export const POSE_INDEX = {
  nose: 0,
  leftEar: 7,
  rightEar: 8,
  leftShoulder: 11,
  rightShoulder: 12,
  leftHip: 23,
  rightHip: 24,
} as const satisfies Record<LandmarkName, number>;

const LANDMARK_NAMES = Object.keys(POSE_INDEX) as LandmarkName[];

/**
 * Chỉ copy 7 điểm cần dùng, không giữ reference tới array của MediaPipe: object đó bị tái sử
 * dụng giữa các frame, giữ lại sẽ khiến ring buffer của Debug Mode (Bước 7) toàn bộ trỏ về
 * cùng một giá trị mới nhất.
 */
export function toLandmarkMap(landmarks: readonly NormalizedLandmark[]): LandmarkMap {
  const out: LandmarkMap = {};
  for (const name of LANDMARK_NAMES) {
    const lm = landmarks[POSE_INDEX[name]];
    if (!lm) continue;
    out[name] = { x: lm.x, y: lm.y, z: lm.z, visibility: lm.visibility };
  }
  return out;
}
